module.exports = __webpack_public_path__ + "img/DieLagune.7cfc4e7e.jpg";